import { Pipe, PipeTransform } from '@angular/core';
import { getNurserySearchKeys } from '../helpers/search.helper';

@Pipe({
  name: 'nurseryFilter'
})
export class NurseriesFilterPipe implements PipeTransform {

  transform(products: any, searchString: string) {
    return (!searchString ? products : // no filter yet, return all
      products.filter((product) => getNurserySearchKeys() // map over each search string
      .map((searchKey => (product.item || product)[searchKey].toUpperCase().indexOf(searchString.toUpperCase()) !== -1)) // true or false on any contains
      .reduce((cumulative, elem) => cumulative === true || elem === true)) // reduce into one answer
    );
  }

}